export const changePasswordFormStyles = {
  submit: {
    marginTop: '25px',
    marginBottom: '25px',
    width: '35%',
    background: '#efa817',
    color: '#fff'
  }
}
